import { keyframes } from '@emotion/react';
import { Box } from '@mui/material';

const sparkPulse = keyframes`
  0%, 100% { transform: scale(0.9); }
  50% { transform: scale(1.1); }
`;

const DEFAULT_STROKE_OPACITY = 0.25;

const SOLID_STROKE_OPACITY = 1;

interface RachelSparkIconProps {
  size?: number;
  isPulsing?: boolean;
  color?: string;
  strokeWidth?: number;
  strokeOpacity?: number;
}

const getStrokeOpacity = ({ isPulsing, color, strokeOpacity }: RachelSparkIconProps) => {
  if (strokeOpacity !== undefined) {
    return strokeOpacity;
  }

  if (color || isPulsing) {
    return SOLID_STROKE_OPACITY;
  }

  return DEFAULT_STROKE_OPACITY;
};

const RachelSparkIcon = ({
  size = 16,
  isPulsing = false,
  color,
  strokeWidth,
  strokeOpacity,
}: RachelSparkIconProps) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      lineHeight: 0,
      flex: 'none',
      ...(color && { color }),
      ...(isPulsing && { animation: `${sparkPulse} 1.5s ease-in-out infinite` }),
    }}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g clipPath="url(#rachel_spark_clip)">
        <path
          d="M7.34466 1.87581C7.37322 1.72287 7.45437 1.58475 7.57405 1.48535C7.69374 1.38595 7.84441 1.33154 7.99999 1.33154C8.15557 1.33154 8.30624 1.38595 8.42592 1.48535C8.54561 1.58475 8.62676 1.72287 8.65532 1.87581L9.35599 5.58114C9.40575 5.84457 9.53377 6.08688 9.72334 6.27645C9.91291 6.46602 10.1552 6.59404 10.4187 6.64381L14.124 7.34447C14.2769 7.37304 14.415 7.45419 14.5144 7.57387C14.6138 7.69355 14.6683 7.84423 14.6683 7.99981C14.6683 8.15538 14.6138 8.30606 14.5144 8.42574C14.415 8.54542 14.2769 8.62657 14.124 8.65514L10.4187 9.35581C10.1552 9.40557 9.91291 9.53359 9.72334 9.72316C9.53377 9.91273 9.40575 10.155 9.35599 10.4185L8.65532 14.1238C8.62676 14.2767 8.54561 14.4149 8.42592 14.5143C8.30624 14.6137 8.15557 14.6681 7.99999 14.6681C7.84441 14.6681 7.69374 14.6137 7.57405 14.5143C7.45437 14.4149 7.37322 14.2767 7.34466 14.1238L6.64399 10.4185C6.59423 10.155 6.46621 9.91273 6.27664 9.72316C6.08707 9.53359 5.84475 9.40557 5.58132 9.35581L1.87599 8.65514C1.72306 8.62657 1.58493 8.54542 1.48553 8.42574C1.38614 8.30606 1.33173 8.15538 1.33173 7.99981C1.33173 7.84423 1.38614 7.69355 1.48553 7.57387C1.58493 7.45419 1.72306 7.37304 1.87599 7.34447L5.58132 6.64381C5.84475 6.59404 6.08707 6.46602 6.27664 6.27645C6.46621 6.08688 6.59423 5.84457 6.64399 5.58114L7.34466 1.87581Z"
          stroke={color ? 'currentColor' : 'url(#rachel_spark_gradient)'}
          strokeOpacity={getStrokeOpacity({ isPulsing, color, strokeOpacity })}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="rachel_spark_gradient"
          x1="-7.49994"
          y1="3.5"
          x2="14.2711"
          y2="-5.42119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC6B4B" />
          <stop offset="1" stopColor="#4876FF" />
        </linearGradient>
        <clipPath id="rachel_spark_clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Box>
);

export default RachelSparkIcon;
